export const IndustryColorsForPiechart: { [key: string]: { bg: string, hover: string } } = {
    'Information Technology': { 
      bg: 'rgba(237, 47, 89, 1)', // rose-500
      hover: 'rgba(190, 24, 60, 1)' // rose-600
    },
    'Health Care': { 
      bg: 'rgba(59, 130, 246, 1)', // blue-500
      hover: 'rgba(37, 99, 235, 1)' // blue-600
    },
    'Financials': { 
      bg: 'rgba(167, 139, 250, 1)', // purple-400
      hover: 'rgba(147, 104, 233, 1)' // purple-500
    },
    'Consumer Discretionary': { 
      bg: 'rgba(245, 158, 11, 1)', // amber-500
      hover: 'rgba(217, 119, 6, 1)' // amber-600
    },
    'Communication Services': { 
      bg: 'rgba(16, 185, 129, 1)', // emerald-500
      hover: 'rgba(5, 150, 105, 1)' // emerald-600
    },
    'Industrials': { 
      bg: 'rgba(75, 85, 99, 1)', // gray-600
      hover: 'rgba(55, 65, 81, 1)' // gray-700
    },
    'Consumer Staples': { 
      bg: 'rgba(124, 58, 237, 1)', // violet-500
      hover: 'rgba(99, 40, 234, 1)' // violet-600
    },
    'Energy': { 
      bg: 'rgba(220, 38, 38, 1)', // red-600
      hover: 'rgba(185, 28, 28, 1)' // red-700
    },
    'Utilities': { 
      bg: 'rgba(236, 72, 153, 1)', // pink-500
      hover: 'rgba(219, 39, 119, 1)' // pink-600
    },
    'Real Estate': { 
      bg: 'rgba(185, 151, 91, 1)', // orange-500
      hover: 'rgba(153, 122, 48, 1)' // orange-600
    },
    'Materials': { 
      bg: 'rgba(96, 165, 250, 1)', // lightBlue-400
      hover: 'rgba(59, 130, 246, 1)' // lightBlue-500
    },
  };
  